<template lang="pug">
.container.grid-lg
  .text-bold.my-2.py-2 Relatórios disponíveis para documentos

  .columns
    .column.col-4.col-lg-6.col-md-12.mb-2.pb-2(v-for="item in items")
      row(v-bind="item", v-acl:allowed="item.acl")
</template>

<script>
import Row from "../components/ReportRow"

export default {
  components: { Row },
  computed: {
    items() {
      return [
        {
          icon: "fa fa-warning",
          title: "Por modelo",
          subtitle: "Quantidade de documentos por modelo",
          to: { name: "app.indicadores.docs.porModelos" },
          acl: ["admin", "indicadores", "docs", "modelos"],
        },
        {
          icon: "fa fa-warning",
          title: "Por modelo X Situação",
          subtitle: "Quantidade de documentos por modelo e situação",
          to: {
            name: "app.indicadores.docs.porModelosSituacao",
          },
          acl: ["admin", "indicadores", "docs", "modelos_por_situacoes"],
        },
        {
          icon: "fa fa-money",
          title: "Valor mensal",
          subtitle: "Valor das documentos por mês",
          to: { name: "app.indicadores.docs.valorMensal" },
          acl: ["admin", "indicadores", "docs", "valores_mensais"],
        },
        {
          icon: "fa fa-bookmark",
          title: "Por situação",
          subtitle: "Quantidade de documentos por situação",
          to: { name: "app.indicadores.docs.porSituacao" },
          acl: ["admin", "indicadores", "docs", "situacoes"],
        },
        {
          icon: "fa fa-bookmark-o",
          title: "Por situação do comentário",
          subtitle: "Quantidade de documentos por situação do comentário",
          to: { name: "app.indicadores.docs.porComentarioSituacoes" },
          acl: ["admin", "indicadores", "docs", "status"],
        },
        {
          icon: "fa fa-globe",
          title: "Por zona",
          subtitle: "Quantidade de documentos por zona",
          to: { name: "app.indicadores.docs.porZona" },
          acl: ["admin", "indicadores", "docs", "zonas"],
        },
        {
          icon: "fa fa-user",
          title: "Por fiscal",
          subtitle: "Quantidade de documentos por fiscal",
          to: { name: "app.indicadores.docs.porFiscal" },
          acl: ["admin", "indicadores", "docs", "fiscais"],
        },
        {
          icon: "fa fa-undo",
          title: "Por reincidência",
          subtitle: "Quantidade de documentos por reincidência",
          to: { name: "app.indicadores.docs.porReincidencia" },
          acl: ["admin", "indicadores", "docs", "reincidencias"],
        },
        {
          icon: "fa fa-users",
          title: "Por Grupo",
          subtitle: "Quantidade de documentos por grupo",
          to: { name: "app.indicadores.docs.porGrupo" },
          acl: ["admin", "indicadores", "docs", "grupos"],
        },
        {
          icon: "fa fa-paperclip",
          title: "Por tipo de documento",
          subtitle: "Quantidade de documentos por tipo de documento",
          to: { name: "app.indicadores.docs.porTipo" },
          acl: ["admin", "indicadores", "docs", "tipos"],
        },
        {
          icon: "fa fa-usd",
          title: "Por faixa de valor",
          subtitle: "Quantidade de documentos por faixa de valor",
          to: { name: "app.indicadores.docs.porFiscalFaixa" },
          acl: ["admin", "indicadores", "docs", "faixa_de_valores"],
        },
        {
          icon: "fa fa-usd",
          title: "Implantados",
          subtitle: "Quantidade de documentos implantados",
          to: { name: "app.indicadores.docs.implantados" },
          acl: ["admin", "indicadores", "docs", "implantados"],
        },
        {
          icon: "fa fa-map-marker",
          title: "Pontos no mapa",
          subtitle: "Pontos no mapa com os cadastros dos Documentos",
          to: { name: "app.indicadores.docs.mapaPontos" },
          acl: ["admin", "indicadores", "docs", "mapas", "pontos"],
        },
        {
          icon: "fa fa-map",
          title: "Densidade no mapa",
          subtitle:
            "Mapa com a demarcação de densidade por incidência de Documentos",
          to: { name: "app.indicadores.docs.mapaDensidade" },
          acl: ["admin", "indicadores", "docs", "mapas", "densidade"],
        },
        {
          icon: "fa fa-user",
          title: "Por fiscal e meses",
          subtitle: "Quantidade de documentos mensal por fiscal",
          to: { name: "app.indicadores.docs.fiscaisPorMeses" },
          acl: ["admin", "indicadores", "docs", "fiscais_por_meses"],
        },
        {
          icon: "fa fa-user",
          title: "Por fiscal e dias",
          subtitle: "Quantidade de documentos diários por fiscal",
          to: { name: "app.indicadores.docs.fiscaisPorDias" },
          acl: ["admin", "indicadores", "docs", "fiscais_por_dias"],
        },
      ]
    },
  },
}
</script>
